import React from 'react';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { SubSectionHeader } from '../shared/SubSectionHeader';
import { FormField } from '../shared/FormField';
import classes from '../../bidAnalysisTemplate.module.scss';

interface FssTrackingSectionProps {
  isExpanded: boolean;
  onToggle: () => void;
  formData: any;
  onFieldChange: (field: string, value: any) => void;
  onFieldBlur: (field: string, value: any) => void;
  onFieldKeyDown?: (field: string, e: React.KeyboardEvent) => void;
}

export const FssTrackingSection: React.FC<FssTrackingSectionProps> = ({
  isExpanded,
  onToggle,
  formData,
  onFieldChange,
  onFieldBlur,
  onFieldKeyDown,
}) => {
  return (
    <div className={classes.subSection}>
      <SubSectionHeader
        title="FSS Tracking Ratio Validation"
        isExpanded={isExpanded}
        onToggle={onToggle}
      />
      {isExpanded && (
        <div className={classes.subSectionContent}>
          <div className={classes.formGrid3}>
            <FormField label="Proposed New Ratio">
              <InputNumber
                value={formData.proposedNewRatio ? parseFloat(formData.proposedNewRatio) : null}
                onValueChange={e => onFieldChange('proposedNewRatio', e.value)}
                onBlur={e => onFieldBlur('proposedNewRatio', e)}
                onKeyDown={e => onFieldKeyDown?.('proposedNewRatio', e)}
                mode="decimal"
                minFractionDigits={0}
                maxFractionDigits={2}
                min={0}
              />
            </FormField>

            <FormField label="Awarded FSS Ratio">
              <InputNumber
                value={formData.awardedFssRatio ? parseFloat(formData.awardedFssRatio) : null}
                onValueChange={e => onFieldChange('awardedFssRatio', e.value)}
                onBlur={e => onFieldBlur('awardedFssRatio', e)}
                onKeyDown={e => onFieldKeyDown?.('awardedFssRatio', e)}
                mode="decimal"
                minFractionDigits={0}
                maxFractionDigits={2}
                min={0}
              />
            </FormField>

            <FormField label="New TC Price">
              <InputNumber
                value={formData.newTcPrice ? parseFloat(formData.newTcPrice) : null}
                onValueChange={e => onFieldChange('newTcPrice', e.value)}
                onBlur={e => onFieldBlur('newTcPrice', e)}
                onKeyDown={e => onFieldKeyDown?.('newTcPrice', e)}
                mode="decimal"
                minFractionDigits={0}
                maxFractionDigits={2}
                min={0}
                prefix="$"
              />
            </FormField>

            <FormField label="Max Price w/out IFF">
              <InputNumber
                value={formData.maxPriceWoutIff ? parseFloat(formData.maxPriceWoutIff) : null}
                onValueChange={e => onFieldChange('maxPriceWoutIff', e.value)}
                onBlur={e => onFieldBlur('maxPriceWoutIff', e)}
                onKeyDown={e => onFieldKeyDown?.('maxPriceWoutIff', e)}
                mode="decimal"
                minFractionDigits={0}
                maxFractionDigits={2}
                min={0}
                prefix="$"
              />
            </FormField>

            <FormField label="Max Price with IFF">
              <InputNumber
                value={formData.maxPriceWithIff ? parseFloat(formData.maxPriceWithIff) : null}
                onValueChange={e => onFieldChange('maxPriceWithIff', e.value)}
                onBlur={e => onFieldBlur('maxPriceWithIff', e)}
                onKeyDown={e => onFieldKeyDown?.('maxPriceWithIff', e)}
                mode="decimal"
                minFractionDigits={0}
                maxFractionDigits={2}
                min={0}
                prefix="$"
              />
            </FormField>

            <FormField label="Ratio OK?">
              <InputText
                value={formData.ratioOk || ''}
                onChange={e => onFieldChange('ratioOk', e.target.value)}
                onBlur={e => onFieldBlur('ratioOk', e.target.value)}
              />
            </FormField>

            <FormField label="Max Price OK?">
              <InputText
                value={formData.maxPriceOk || ''}
                onChange={e => onFieldChange('maxPriceOk', e.target.value)}
                onBlur={e => onFieldBlur('maxPriceOk', e.target.value)}
              />
            </FormField>
          </div>
        </div>
      )}
    </div>
  );
};
